module.exports = __webpack_public_path__ + "img/leicester.b7233e60.png";